import { AfterViewInit, Component, effect, inject, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CatalogProduct } from '@banyan/commons/models/admin/catalog-product.model';
import {
  AdminSearchProductModalComponent
} from '@banyan/modules/admin/components/admin-search-product-modal/admin-search-product-modal.component';
import { AdminService } from '@banyan/modules/admin/services/admin.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-admin-catalog',
  templateUrl: './admin-catalog.component.html',
  styleUrl: './admin-catalog.component.scss',
})
export class AdminCatalogComponent implements AfterViewInit{
  @ViewChild(MatSort) sort!: MatSort;
  adminService = inject(AdminService);
  dialog = inject(MatDialog);
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['imageUrl', 'name', 'price', 'lastUpdated'];
  totalRecords: number = 0;
  currentPage: number = 1;

  constructor() {
    this.loadCatalog(1);
    this.dataSource.filterPredicate = (data: CatalogProduct, filter: string) => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.id.toString().toLowerCase().includes(transformedFilter) ||
        data.name.toString().toLowerCase().includes(transformedFilter)
      );
    };
    effect(() => {
      if (this.adminService.catalogLoaded()) {
        this.dataSource.data = this.adminService.catalog()?.data ?? [];
        this.totalRecords = this.adminService.catalog()?.pagination.totalCount ?? 0;
      }
    });
  }

  loadCatalog(currentPage: number) {
    this.adminService.getCatalog(10, currentPage);
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/catalog-default-product.png';
  }

  ngAfterViewInit() {
    this.sortingTable();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  sortingTable() {
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (data: CatalogProduct, sortHeaderId: string) => {
        switch (sortHeaderId) {
          case 'name':
            return data.name;
          case 'lastUpdated':
            return new Date(data.lastUpdated);
          case 'price':
            return data.price;
          default:
            return (data as any)[sortHeaderId] ?? '';
        }
      };
    }
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.loadCatalog(this.currentPage);
  }

  openProductsSearchModal(): void {
    const dialogRef = this.dialog.open(AdminSearchProductModalComponent,
      {
        maxWidth: '1140px',
        maxHeight: '600px',
        width: '85vw',
        height: '80vh',
        data: {
          buttonText: 'catalogue'
        }
      });
    dialogRef
      .backdropClick()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef.close();
      });
    dialogRef.afterClosed().subscribe((change: boolean) => {
      if (change) {
        this.adminService.addCatalogProducts();
      }
    });
  }
}
